import React, { useState } from "react";
import AllRequestsTable from "../Tables/Table/AllRequestTable";
import FilterSelect from "./FilterSelect";
import Tabs from "./Tabs";
import ArchivedToggle from "./ArchivePart";
import useRequestData from "./useRequestData";
import PartRequestDetails from "../RequestComponents/PartRequestDetails";
import Breadcrumb from '../../../SharedComponents/components/Breadcrumb/Breadcrumb';

const WithRequests = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [selectedTab, setSelectedTab] = useState("svi");
  const [showArchived, setShowArchived] = useState(false);
  const [selectedCars, setSelectedCars] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const {
    loading,
    requestData,
    newRequests,
    activePartRequests,
    completedPartRequests,
    archivedPartRequests,
    fetchTabData,
    fetchArchived,
  } = useRequestData(selectedTab, showArchived, page, rowsPerPage);


  if (loading) return <div>Loading...</div>;

  const handleTabClick = async (tab) => {
    if (tab !== "arhivirani") setShowArchived(false);
    setPage(0);
    await fetchTabData(tab);
    setSelectedTab(tab);
  };


  const handleArchivedClick = async () => {
    if (!showArchived) {
      await fetchArchived();
    }
    setShowArchived(!showArchived);
  };

  if (selectedId !== null) {
    return <PartRequestDetails id={selectedId} onBack={() => setSelectedId(null)} />;
  }

  const applyCarFilter = (requests) => {
    const selectedIds = selectedCars.map((car) => car.value);
    return selectedCars.length > 0
      ? requests.filter((req) => selectedIds.includes(req.id_car_generation))
      : requests;
  };

  let displayedRequests = [];
  if (selectedTab === "novi") {
    displayedRequests = applyCarFilter(newRequests);
  } else if (selectedTab === "aktivni") {
    displayedRequests = applyCarFilter(activePartRequests);
  } else if (selectedTab === "zavrseni") {
    displayedRequests = applyCarFilter(completedPartRequests);
  } else if (selectedTab === "svi") {
    displayedRequests = applyCarFilter(requestData);
  }

  const countByStatus = {
    novi: newRequests.length,
    aktivni: activePartRequests.length,
    zavrseni: completedPartRequests.length,
    svi: requestData.length,
    arhivirani: archivedPartRequests.length,
  };

  const breadcrumbs = [
    { title: 'Početak', href: '/home-page' },
    { title: 'Zahtevi za ponude', href: '#' }
  ];

  const title = 'Zahtevi za ponude';

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.breadcrumbWrapper}>
        <Breadcrumb title={title} breadcrumbs={breadcrumbs} />
      </div>

      <div style={styles.topControlsWrapper}>
        <div style={styles.tabsWrapper}>
          <Tabs
            selectedTab={selectedTab}
            handleTabClick={handleTabClick}
            countByStatus={countByStatus}
          />
        </div>

        <div style={styles.filterSelectWrapper}>
          <FilterSelect
            newPartRequests={requestData}
            selectedCars={selectedCars}
            setSelectedCars={setSelectedCars}
          />
        </div>
      </div>

      <AllRequestsTable
        count={displayedRequests.length}
        fetchedActiveCarRequests={displayedRequests}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        page={page}
        setPage={setPage}
        onRowSelect={(id) => setSelectedId(id)}
      />

      <ArchivedToggle
        onClick={handleArchivedClick}
        count={countByStatus.arhivirani}
        showArchived={showArchived}
      />

      {showArchived && (
        <div style={styles.archivedSection}>
          <h3>Arhivirani zahtevi</h3>
          <AllRequestsTable
            count={archivedPartRequests.length}
            fetchedActiveCarRequests={archivedPartRequests}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            page={page}
            setPage={setPage}
            onRowSelect={(id) => setSelectedId(id)}
          />
        </div>
      )}
    </div>
  );
};

export default WithRequests;

const styles = {
  pageWrapper: {
    padding: "20px",
  },
  breadcrumbWrapper: {
    marginBottom: "30px",
    marginTop: "20px",
  },
  topControlsWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "20px",
    gap: "12px",
  },
  tabsWrapper: {
    flex: "1 1 auto",
  },
  filterSelectWrapper: {
    flex: "1 1 auto",
    maxWidth: "400px",
    minWidth: "250px",
  },
  archivedSection: {
    marginTop: "40px",
  },
};
